import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const useImageReady = (src) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (src) {
      const img = new Image();
      img.onload = () => setReady(true);
      img.onerror = () => setReady(false);
      img.src = src;
    }
  }, [src]);
  return ready;
};

const Avatar = ({ src, title, alt, style, border }) => {
  const isReady = useImageReady(src);
  if (src && isReady) {
    return (
      <img
        src={src}
        title={title}
        alt={title || alt}
        className={`circle ${border ? 'border' : ''} fit user-avatar`}
      />
    );
  }
  return (
    <div
      className={`circle ${border ? 'border' : ''} user-avatar`}
      style={style}
    />
  );
};

Avatar.defaultProps = {
  src: null,
  alt: null,
  title: null,
  style: null,
};

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.object,
};

export default Avatar;
